import { NetworkError, NetworkErrorBoundary } from '@data-client/react';
import React, { ComponentType, Suspense } from 'react';

interface AsyncBoundaryProps {
  children: JSX.Element;
  errorFallback: ({ error }: { error: NetworkError }) => JSX.Element;
  loadingFallback: ComponentType;
}

export default function AsyncBoundary({
  children,
  errorFallback,
  loadingFallback
}: AsyncBoundaryProps) {
  return (
    <Suspense fallback={React.createElement(loadingFallback)}>
      <NetworkErrorBoundary fallbackComponent={errorFallback}>
        {children}
      </NetworkErrorBoundary>
    </Suspense>
  );
}
